import { AxiosRequestConfig } from 'axios'

import { CreateStorePayload, UpdateStoreData } from './types'
import { getActiveTags } from '../Tags/api'

const getStores = (): AxiosRequestConfig => ({
  url: '/stores',
  method: 'GET',
})

const getActiveStores = (params?: { includeIds?: number[] }): AxiosRequestConfig => {
  const searchParams = new URLSearchParams({ active: 'true' })
  if (params?.includeIds?.length) searchParams.set('includeIds', params.includeIds.join(','))

  return {
    url: `/stores?${searchParams.toString()}`,
    method: 'GET',
  }
}

const createStore = (store: CreateStorePayload): AxiosRequestConfig => {
  const payload = new FormData()

  payload.append('name', store.name)
  payload.append('secondaryName', store.secondaryName)
  payload.append('description', store.description)
  payload.append('usdEnabled', store.usdEnabled.toString())
  payload.append('pointsEnabled', store.pointsEnabled.toString())
  payload.append('active', store.active.toString())
  payload.append('rut', store.rut)
  if (store.serie) {
    payload.append('serie', store.serie)
  }

  if (store.tagIds && store.tagIds.length > 0) {
    payload.append('tagIds', store.tagIds.join(',')) // Convertimos array en string
  }

  if (store.logoUrl) {
    payload.append('logoUrl', store.logoUrl) // Ahora coinciden con la API
  }
  if (store.storeImageUrl) {
    payload.append('storeImageUrl', store.storeImageUrl)
  }

  return {
    url: '/stores',
    method: 'POST',
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
}

const updateStore = (store: UpdateStoreData): AxiosRequestConfig => {
  const payload = new FormData()

  payload.append('id', store.id.toString())
  payload.append('name', store.name)
  payload.append('secondaryName', store.secondaryName)
  payload.append('description', store.description)
  payload.append('usdEnabled', store.usdEnabled.toString())
  payload.append('pointsEnabled', store.pointsEnabled.toString())
  payload.append('active', store.active.toString())
  payload.append('rut', store.rut)
  payload.append('serie', store.serie ?? '')

  if (store.tagIds) {
    const tagIdsString = Array.isArray(store.tagIds) ? store.tagIds.join(',') : store.tagIds // ya es string

    payload.append('tagIds', tagIdsString)
  }

  if (store.logoUrl instanceof File) {
    payload.append('logoUrl', store.logoUrl)
  }

  if (store.storeImageUrl instanceof File) {
    payload.append('storeImageUrl', store.storeImageUrl)
  }

  return {
    url: `/stores/${store.id}`,
    method: 'PUT',
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
}

const deleteStore = (id: number): AxiosRequestConfig => ({
  url: `/stores/${id}`,
  method: 'DELETE',
})

export { getStores, getActiveStores, createStore, updateStore, deleteStore, getActiveTags }
